import { Guid } from 'guid-typescript'
import { snakeCase } from 'lodash'
import VueI18n from 'vue-i18n'

import { successNotificationWrapper } from '../../../../../../logic/helpers/NotificationService'
import CustomEditor from '../../../logic/Editor/CustomEditor'
import { CustomNode, NodeTypes } from '../../../logic/Nodes'
import { MenuSectionNames } from '../types'

export const BaseMenuItems: Array<CtxMenuItem> = [
  {
    key: Guid.create().toString(),
    title: `flow_context_menu_${ MenuSectionNames.Communications }`,
    icon: { type: 'message', class: "text-danger" },
    items: [
      {
        key: Guid.create().toString(),
        title: `flow_${ snakeCase(NodeTypes.SendMessage) }_node_name`,
        value: NodeTypes.SendMessage,
        icon: { type: 'message' }
      },
      {
        key: Guid.create().toString(),
        title: `flow_${ snakeCase(NodeTypes.SendInvoice) }_node_name`,
        value: NodeTypes.SendInvoice,
        icon: { type: 'shopping_cart' }
      },
      {
        key: Guid.create().toString(),
        title: `flow_${ snakeCase(NodeTypes.EditLastMessage) }_node_name`,
        value: NodeTypes.EditLastMessage,
        icon: { type: 'edit' }
      },
      {
        key: Guid.create().toString(),
        title: `flow_${ snakeCase(NodeTypes.ForwardMessage) }_node_name`,
        value: NodeTypes.ForwardMessage,
        icon: { type: 'reply' }
      },
    ]
  },
  {
    key: Guid.create().toString(),
    title: `flow_${ snakeCase(NodeTypes.Randomizer) }_node_name`,
    value: NodeTypes.Randomizer,
    icon: { type: 'call_split' },
  },
  {
    key: Guid.create().toString(),
    title: `flow_${ snakeCase(NodeTypes.Conditions) }_node_name`,
    value: NodeTypes.Conditions,
    icon: {
      type: 'fork_left',
      class: "text-primary"
    },
  },
  {
    key: Guid.create().toString(),
    title: `flow_${ snakeCase(NodeTypes.Delay) }_node_name`,
    value: NodeTypes.Delay,
    icon: {
      type: 'more_time'
    }
  },
  {
    key: Guid.create().toString(),
    title: `flow_${ snakeCase(NodeTypes.Action) }_node_name`,
    value: NodeTypes.Action,
    icon: {
      type: 'construction'
    }
  },
  {
    key: Guid.create().toString(),
    title: `flow_context_menu_${ MenuSectionNames.Limited }`,
    icon: { type: 'payment', class: 'text-success' },
    items: [
      {
        key: Guid.create().toString(),
        title: `flow_${ snakeCase(NodeTypes.CheckLimitedSubscription) }_node_name`,
        value: NodeTypes.CheckLimitedSubscription,
        icon: { type: 'price_check' }
      },
      {
        key: Guid.create().toString(),
        title: `flow_${ snakeCase(NodeTypes.CreateLimitedSubscription) }_node_name`,
        value: NodeTypes.CreateLimitedSubscription,
        icon: { type: 'add_shopping_cart' }
      },
      {
        key: Guid.create().toString(),
        title: `flow_${ snakeCase(NodeTypes.InfoLimitedSubscription) }_node_name`,
        value: NodeTypes.InfoLimitedSubscription,
        icon: { type: 'info' }
      },
    ]
  },
  {
    key: Guid.create().toString(),
    title: `flow_context_menu_${ MenuSectionNames.Additionally }`,
    icon: { type: 'manage_search' },
    items: [
      {
        key: Guid.create().toString(),
        title: `flow_${ snakeCase(NodeTypes.CheckSubscription) }_node_name`,
        value: NodeTypes.CheckSubscription,
        icon: { type: 'check_circle_outline' }
      },
      {
        key: Guid.create().toString(),
        title: `flow_${ snakeCase(NodeTypes.RunFlow) }_node_name`,
        value: NodeTypes.RunFlow,
        icon: { type: 'lan' }
      },
      {
        key: Guid.create().toString(),
        title: `flow_${ snakeCase(NodeTypes.HttpRequest) }_node_name`,
        value: NodeTypes.HttpRequest,
        icon: { type: 'http' }
      },
      {
        key: Guid.create().toString(),
        title: `flow_${ snakeCase(NodeTypes.Integration) }_node_name`,
        value: NodeTypes.Integration,
        icon: { type: 'integration_instructions' }
      },
    ]
  },
]

export const PasteMenuItem = {
  key: Guid.create().toString(),
  title: 'context_menu_paste',
  icon: {
    type: 'content_paste_go'
  }
}

export const getNodeActionsMenuItems = (closeMenu: () => void, copyNodes: CustomEditor['copyNodes'], removeNode: CustomEditor['removeNode'], i18n: VueI18n) => [
  {
    key: Guid.create().toString(),
    title: 'context_menu_copy',
    icon: {
      type: 'content_copy'
    },
    value: (nodes: CustomNode[]) => {
      copyNodes(nodes)

      closeMenu()
      successNotificationWrapper(i18n.t('success_copy').toString(), '')
    },
  },
  {
    title: 'flow_context_menu_delete',
    key: Guid.create().toString(),
    icon: {
      type: 'delete_outline',
      class: "text-danger"
    },
    value: (nodes: CustomNode[]) => nodes.forEach((n) => removeNode(n)),
  },
]

export type CtxMenuItem = {
  key: string
  title: string
  value?: any
  items?: Array<CtxMenuItem>
  icon?: {
    type: string
    class?: string
  }
}
